export function isInShadow(node: Node): boolean {
  return node.getRootNode() instanceof ShadowRoot;
}

export function appendStylesheet({ target, styles, name }: { target: Node; styles: string; name: string; }) {
  const rootNode: HTMLElement | ShadowRoot = isInShadow(target) ? target.getRootNode() as ShadowRoot : document.body;

  if (!rootNode.querySelector(`[${name}]`)) {
    const styleEl = document.createElement('style');
    styleEl.setAttribute(name, '');
    styleEl.innerHTML = styles;
    rootNode.appendChild(styleEl);
  }
}

export type deferred = { 
  promise: Promise<void>, 
  resolve: () => void, 
  reject: () => void
};

export function makeDeferred(): deferred  {
  const def: any = { };
  def.promise = new Promise((resolve, reject) => {
    def.resolve = resolve;
    def.reject = reject;
  });
  return def;
}
